import { gql } from '@apollo/client';

export const UPDATE_DEPENDENT = gql`
  mutation UpdateDependent($dependent: DependentDtoInput) {
      updateDependent(dependent: $dependent) {
        id
      }
    }
`;
